import { createAsyncThunk } from '@reduxjs/toolkit';

import { removeUndefined } from 'commonUtils/removeUndefined';

import { sendSentryClientErrorOnce } from 'shared/lib';

import type { TCreditFormCommonFields } from 'entities/creditForm';
import {
  formDataToCustomerAdapter,
  prepareFormDataForCustomerUpdate,
  selectRequiredFieldsForUpdate,
  setIsUserDataLoadingEnd,
  setIsUserDataLoadingStart,
} from 'entities/creditForm';
import { selectIsSelectedProductTypeFeatureEnabled } from 'entities/siteSettings';
import { isLoggedSelector } from 'entities/user/model/user.selectors';

import { sendCustomerDataApi } from '../model/sendCustomerData.query';
import type { TSendCustomerDataThunkState } from '../model/sendCustomerData.types';

export const sendCustomerDataThunk = createAsyncThunk<
  void,
  Partial<TCreditFormCommonFields>,
  { state: TSendCustomerDataThunkState }
>('sendCustomerData/sendCustomerDataThunk', async (payload, { dispatch, getState }) => {
  const isLoggedIn = isLoggedSelector(getState());

  if (!isLoggedIn) {
    return;
  }

  const formFields = { ...selectRequiredFieldsForUpdate(getState()), ...payload };
  const shouldIncludeSelectedProductType = selectIsSelectedProductTypeFeatureEnabled(getState());
  const preparedFormData = prepareFormDataForCustomerUpdate(formFields, shouldIncludeSelectedProductType);

  // проверяем заполнение обязательных полей, так как без них сохранение будет падать с ошибкой
  if (
    (
      ['fullName', 'birthDate', 'passportNumber', 'passportIssueDate', 'passportIssuedBy', 'unitCode'] as Array<
        Partial<keyof TCreditFormCommonFields>
      >
    ).some((key) => !formFields[key])
  ) {
    return;
  }

  try {
    // TODO отказаться от setIsUserDataLoadingStart и перейти на extraReducers builder.addCase
    dispatch(setIsUserDataLoadingStart());
    await dispatch(
      sendCustomerDataApi.endpoints.updateCustomerData.initiate(
        removeUndefined(formDataToCustomerAdapter(preparedFormData), [null, ''], true),
      ),
    ).unwrap();
  } catch (error) {
    sendSentryClientErrorOnce('sendCustomerDataThunk', error);
  } finally {
    dispatch(setIsUserDataLoadingEnd());
  }
});
